import React, { useEffect, useMemo } from "react";
import { FilterOutlined } from "@ant-design/icons";
import Modal from "components/Modal/Modal";
import { Button } from "components/Buttons/Buttons";
import { FormRadioGroup, FormSelect } from "components/FormItems/FlatFormItems";
import { useSelector } from "react-redux";
import { CalenderOperationType } from "utils/enums";
import { Form } from "antd";
import { uniqBy } from "lodash";

export default function GFEFilter({ selectedNP, onSelectedNPChange }) {
  const [form] = Form.useForm();

  const [showFilter, setShowFilter] = React.useState(false);
  const allRoles = useSelector((state) => state.roles.allRoles);

  const { wholeStaff } = useSelector((state) => ({
    wholeStaff: state.user.wholeStaff,
  }));

  const filteredStaff = wholeStaff?.filter((staff) => {
    const role = allRoles?.find?.((role) => role.roleId === staff?.roleId);
    if (
      role?.permissions?.find?.(
        (permission) => permission.permissionName === "GFE Signature"
      )
    )
      return true;
    return false;
  });

  const { facilities, isFetchingFacilities } = useSelector((state) => {
    return {
      facilities: state.facilities.allFacilities,
      isFetchingFacilities: state.facilities.isFetchingFacilities,
    };
  });

  const states = useMemo(() => {
    return uniqBy(facilities, "state")?.map((f) => ({
      stateId: f.stateId,
      stateName: f.state,
    }));
  }, [facilities]);

  useEffect(() => {
    // TODO: handle initial form values on modal show
    if (showFilter) {
      console.log('selectedNp', selectedNP)
      const nursePhysician1Ids = typeof selectedNP?.nursePhysician1Ids === 'object' ? selectedNP?.nursePhysician1Ids[0] : selectedNP?.nursePhysician1Ids
      const nursePhysician2Ids = typeof selectedNP?.nursePhysician2Ids === 'object' ? selectedNP?.nursePhysician2Ids[0] : selectedNP?.nursePhysician2Ids

      form.setFieldsValue({
        // facilityIds: selectedNP?.facilityIds ?? [],
        stateId: selectedNP?.stateId ?? undefined,
        nursePhysician1Ids: nursePhysician1Ids,
        nursePhysician2Ids: nursePhysician2Ids,
        status: selectedNP?.status ?? undefined,
      });
    } else {
      // form.resetFields();
    }
  }, [showFilter, selectedNP]);


  const hasFilterValue = useMemo(() => {
    return Object.keys(selectedNP).find(key => {
      if (typeof selectedNP[key] === 'object' && selectedNP?.[key]?.length > 0) {
        return true
      }
      else if (typeof selectedNP[key] !== 'object' && selectedNP[key] !== undefined && selectedNP[key] !== null)
        return true
      return false
    })
  }, [selectedNP])


  return (
    <>
      <button
        className={`calenderFilterBtn ${hasFilterValue ? "active" : ""}`}
        onClick={() => {
          setShowFilter(true);
        }}
        style={{ borderRadius: 6 }}
      >
        <FilterOutlined style={{ fontSize: 18 }} />
      </button>
      <Modal
        title="Filters"
        open={showFilter}
        // onOk={() => {}}
        onCancel={() => {
          setShowFilter(false);
        }}
        footer={[]}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={(values) => {
            for (const key in values) {
              if (values[key] === undefined || values[key] === null) {
                delete values[key];
              }
            }

            if (Object.keys(values).length === 0) {
              onSelectedNPChange({
                stateId: undefined,
                nursePhysician1Ids: undefined,
                nursePhysician2Ids: undefined,
                status: undefined
              });
            } else {
              onSelectedNPChange({
                stateId: values.stateId,
                nursePhysician1Ids: values.nursePhysician1Ids
                  ? [values.nursePhysician1Ids]
                  : [],
                nursePhysician2Ids: values.nursePhysician2Ids
                  ? [values.nursePhysician2Ids]
                  : [],
                status: values.status,
                operationTypeIds:
                  !values?.operationTypeId ||
                    values?.operationTypeId === CalenderOperationType.All
                    ? []
                    : [values.operationTypeId],
                facilityIds: values?.facilityIds ?? [],
              });
            }
            setShowFilter(false);
          }}
          initialValues={{
            operationTypeId: CalenderOperationType.All,
          }}
          defaultValue={{
            operationTypeId: CalenderOperationType.All,
          }}
        >
          <FormSelect
            name="stateId"
            formItemStyles={{
              width: "100%",
            }}
            variant="underlined"
            label="State"
            placeholder="State"
            options={states}
            renderValue="stateId"
            renderLabel="stateName"
            filterOption={(input, option) => {
              return option?.label
                ?.toLowerCase?.()
                .includes?.(input.toLowerCase());
            }}
            allowClear={true}
            showSearch={true}
          />

          <FormSelect
            name="nursePhysician1Ids"
            formItemStyles={{
              width: "100%",
            }}
            variant="underlined"
            label="NP/Physician 1"
            placeholder="Nurse"
            options={filteredStaff}
            renderValue="staffId"
            renderLabel="name"
            optionLabelProp="label"
            filterOption={(input, option) => {
              return option?.label
                ?.toLowerCase?.()
                .includes?.(input.toLowerCase());
            }}
            renderOption={(opt) => {
              return opt["name"];
            }}
            allowClear={true}
            showSearch={true}
          />

          <FormSelect
            name="nursePhysician2Ids"
            formItemStyles={{
              width: "100%",
            }}
            variant="underlined"
            label="NP/Physician 2"
            placeholder="NP/Physician"
            options={filteredStaff}
            renderValue="staffId"
            renderLabel="name"
            optionLabelProp="label"
            filterOption={(input, option) => {
              return option?.label
                ?.toLowerCase?.()
                .includes?.(input.toLowerCase());
            }}
            renderOption={(opt) => {
              return opt["name"];
            }}
            allowClear={true}
            showSearch={true}
          />

          <FormSelect
            name="status"
            formItemStyles={{
              width: "100%",
            }}
            variant="underlined"
            label="Status"
            placeholder="Status"
            options={[
              { label: "Unassigned", value: 1 },
              { label: "Assigned", value: 2 },
              { label: "Pending", value: 3 },
              { label: "Completed", value: 4 },
            ]}
            filterOption={(input, option) => {
              return option?.label
                ?.toLowerCase?.()
                .includes?.(input.toLowerCase());
            }}
            renderLabel={"label"}
            renderValue="value"
            allowClear={true}
            showSearch={true}
          />

          <div style={{ gap: 12, display: "flex" }}>
            <Button
              htmlType={"submit"}
              rounded={true}
              onClick={() => {
                // dispatch(setCurrentStaffIds([]));
                // onSelectedNPChange();
              }}
            >
              Submit
            </Button>
            <Button
              rounded={true}
              onClick={() => {
                // dispatch(setCurrentStaffIds([]));
                // onSelectedNPChange();
                form.resetFields();
              }}
            >
              Clear
            </Button>
          </div>
        </Form>
      </Modal>
    </>
  );
}
